import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppStatus} from './appStatus.model';

@Injectable({
	providedIn: 'root'
})
export class StatutService {
	private url = '/ws/admin';

	constructor(private http: HttpClient) {
	}

	setApplicationDown() {
		return this.http.post(this.url + '/down', null, {responseType: 'text'});
	}

	setApplicationUp() {
		return this.http.post(this.url + '/up', null, {responseType: 'text'});
	}

	getApplicationStatus(): Observable<AppStatus> {
		return this.http.get<AppStatus>(this.url + '/status');
	}
}
